
























































import { Component, Vue } from 'vue-property-decorator'
import carouselPictureApi from '@/api/marketing/rewardPointMall/carouselPicture/index'
import PicModal from '@/components/upload/picModal.vue'
import RewardPointProductSelect from '@/components/reward-point-product-select/index.vue'
import SelectUrl from '@/components/selectUrl/index.vue'
@Component({
  components: {
    PicModal,
    RewardPointProductSelect,
    SelectUrl,
  },
})
export default class Banner extends Vue {
  banners: any[] = [
    {
      pictureUrl: '',
      linkType: 0,
      link: '',
      displayOrder: 1,
    },
  ]
  mounted() {
    this.load()
  }
  load() {
    carouselPictureApi.getCarouselPictureList().then((res) => {
      if (res.data.items.length > 0) {
        this.banners = res.data.items
      }
    })
  }
  picChange(index, e) {
    console.log(e)
    this.banners[index].pictureUrl = e[0].url
  }
  up(index: number) {
    var item = this.banners.splice(index, 1)
    this.banners.splice(index - 1, 0, ...item)
  }
  down(index: number) {
    var item = this.banners.splice(index, 1)
    this.banners.splice(index + 1, 0, ...item)
  }
  remove(index: number) {
    this.banners.splice(index, 1)
  }

  add() {
    let obj = {
      pictureUrl: '',
      linkType: 0,
      link: '',
      displayOrder: 1,
    }
    this.banners.push(obj)
  }
  save() {
    carouselPictureApi.addCarouselPicture(this.banners).then((res) => {
      this.$Message.success('保存成功')
    })
  }

  urlChange(e, index) {
    this.banners[index].link = e
  }
}
